module.exports = __webpack_public_path__ + "static/img/hnq0824.e2ce6d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hnq0824.jpg
// module id = iimA
// module chunks = 0